import React from "react";
import StyledBackgroundSection from "../sections/bg-section";

function HomeTopCTA() {
  return <StyledBackgroundSection className="container mx-auto flex flex-col md:flex-row items-center" />;
}
export default HomeTopCTA;
